// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chips-row[data-v-19cc7a52] {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 2px 0;\n}\n\n/* El folio no se restringe de ancho para mostrar el codigo completo */\n.folio-chip[data-v-19cc7a52] {\n  max-width: none;\n}\n.folio-chip .vs-chip--text[data-v-19cc7a52] {\n  max-width: none;\n  overflow: visible;\n  text-overflow: unset;\n}\n", ""]);
// Exports
module.exports = exports;
